// extracted by mini-css-extract-plugin
module.exports = {"thumb":"styles_thumb__u5QQp","liked":"styles_liked__SfWhv","like":"styles_like__Gvm4o"};